// SuperInsightsModal.js
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import SuperInsightsContent from "./SuperInsightsContent";

const SuperInsightsModal = ({ isOpen, toggle, textoIA }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader className="position-relative border-2 border-top-0 border-start-0 border-end-0 border-color-cinza3">
        <div className="d-flex align-items-center">
          <i className="fas fa-microchip micro-modal me-2 text-color-azul2"></i>
          <h4 className="m-0 fw-bold text-color-azul1" >
            SuperInsights
          </h4>
        </div>
        <button
          onClick={toggle}
          className="btn p-0 border-0 bg-transparent"
          style={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
            fontSize: "10px",
            lineHeight: "1"
          }}
          aria-label="Fechar"
        >
          
          <i className="fas font-size-24 fa-times text-muted"></i>
          
        </button>
      </ModalHeader>

      <ModalBody className="p-4" style={{ height: "70vh", overflowY: "auto" }}>

        <h5 className="text-color-azul1 fw-bold">Análise</h5>          
        <SuperInsightsContent textoIA={textoIA} />
        
        <div className="border rounded p-3 mt-4 border-color-cinza1">
          <p className="mb-0 text-dark-gray-primary font-size-10">
            O <strong>SuperInsights</strong>, da plataforma{" "}
            <strong>Business Integrator</strong>, é uma ferramenta de{" "}
            <strong>IA</strong> que analisa dados de compra, venda, faturamento,
            ruptura e outros indicadores do seu negócio.
          </p>
          <p className="mb-0 mt-2 text-dark-gray-primary font-size-10">
            Identificamos padrões, riscos e oportunidades, gerando{" "}
            <strong>insights</strong> para{" "}
            <strong>otimizar operações, reduzir custos e alinhar estratégias</strong>{" "}
            que te ajudam a tomar decisões baseadas em dados, impulsionando
            produtividade e eficiência.
          </p>
        </div>
  
      </ModalBody>

      <ModalFooter className="pt-4 border-top-0">       
      </ModalFooter>
    </Modal>
  );
};

export default SuperInsightsModal;
